import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../infrastructure/redux/store'
import { getPhasedayBySign } from '../../infrastructure/repositories/casaArcanaRepository.ts'

export const fetchPhaseday = createAsyncThunk(
  'phaseday/fetch',
  async (sign: string, { getState }) => {
    const state = getState() as RootState
    const baseURL = state.api.baseURL
    return await getPhasedayBySign(baseURL, sign)
  }
)